import React from 'react';
import {getCustomValidityMessage} from '../../../../constants/HyperWalletConstants';
import HyperWalletCardDropdown from '../HyperWalletCardDropdown';

const PaymentSummaryStepCreditCardFields = (props) => {
  return (
    <div>
      <div className='row'>
        <div className='col-lg-6 mt-2'>
          <label htmlFor='paymentAmountPS'>Payment Amount</label>
          <div className='input-group mb-3'>
            <div className='input-group-prepend'>
              <span className='input-group-text' id='dollar-addon'>
                $
              </span>
            </div>
            <input
              type="number" min={5} max={3000} step="any"
              className='form-control'
              id='paymentAmountPS'
              value={props.paymentAmount}
              onChange={props.handleChangePaymentAmount}
              aria-describedby='dollar-addon'
              onInvalid={(e)=>{e.target.setCustomValidity(getCustomValidityMessage(e.target.validity))}}
              onInput={(e)=>{e.target.setCustomValidity('')}}
            />
          </div>
        </div>
        <div className='col-lg-6 mt-2'>
          <label htmlFor='selectedCardPS'>Payment Method</label>
          <HyperWalletCardDropdown
            cards={props.cards}
            selectedCard={props.selectedCard}
            setSelectedCard={props.setSelectedCard}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSummaryStepCreditCardFields;
